import type { ContentHref } from '@generalTypes/apiTypes';
import { getAngularService } from '@kathondvla/react-shared-components/src/helpers/angularReactHelper';
import {
  selectRawWebPage,
  selectRealRootItem,
  selectWebPage,
} from '@newStore/documentApi/documentApiSelectors';
import type { EditComponentProperty } from '@nodeTypeConfig/configTypes';
import type { PayloadAction } from '@reduxjs/toolkit';
import {
  updateDocumentViewModelAction,
  updateWebsiteConfigurationActionNew,
} from '@store/actions/documentActions';
import { UPDATE_WEBSITE_CONFIGURATION_NEW } from '@store/constants/actionTypes';
import { debounce, put, select } from 'redux-saga/effects';

function* addChangedPathToOldLocations({
  payload,
}: PayloadAction<{ contentHref: ContentHref; path: EditComponentProperty; value: any }>) {
  const { contentHref, path, value } = payload;
  const isRootIssued = yield select((state) =>
    Boolean(selectRealRootItem(state, contentHref)?.issued),
  );
  const rawWebPage: ReturnType<typeof selectRawWebPage> = yield select((state) =>
    selectRawWebPage(state, contentHref),
  );
  const currentWebPage: ReturnType<typeof selectWebPage> = yield select((state) =>
    selectWebPage(state, contentHref),
  );
  const oldLocations = currentWebPage?.oldLocations || [];

  const isAlreadyInOldUrls = oldLocations.some(
    (oldLocation) =>
      oldLocation.path === rawWebPage?.path && oldLocation.website.href === rawWebPage.website.href,
  );

  if (
    isRootIssued &&
    !isAlreadyInOldUrls &&
    rawWebPage?.path &&
    path === 'path' &&
    rawWebPage?.path !== value
  ) {
    const confirmation = yield getAngularService('ConfirmationService').confirm({
      confirmationMessage:
        "Je wijzigde de url, verwijzingen naar deze url zullen niet meer werken. Wil je deze url toevoegen aan de vorige url's ?",
    });

    if (confirmation) {
      yield put(
        updateWebsiteConfigurationActionNew(contentHref, 'oldLocations', [
          ...oldLocations,
          {
            path: rawWebPage.path,
            website: rawWebPage.website,
          },
        ]),
      );
    }
  }

  yield put(updateDocumentViewModelAction(true));
}

export function* documentAsideSaga() {
  yield debounce(1000, UPDATE_WEBSITE_CONFIGURATION_NEW, addChangedPathToOldLocations);
}
